'use strict';

export const UPDATE_SHARE_BUTTONS_SHARING_EXPANDED_TYPE = 'UPDATE_SHARE_BUTTONS_SHARING_EXPANDED_TYPE';
export const UPDATE_SHARE_BUTTONS_EMBED_CODE_EXPANDED = 'UPDATE_SHARE_BUTTONS_EMBED_CODE_EXPANDED';

export function changeSharingExpandedType(payload) {
    return {
        type: UPDATE_SHARE_BUTTONS_SHARING_EXPANDED_TYPE,
        payload,
    };
}

export function changeEmbedCodeExpanded(payload) {
    return {
        type: UPDATE_SHARE_BUTTONS_EMBED_CODE_EXPANDED,
        payload,
    };
}
